// src/services/sessionWatcher.js
import { decodeJwt, redirectToLogin } from './api';

let timeoutId = null;

/**
 * Programa el auto-logout basado en el `exp` del JWT actual.
 */
export const scheduleAutoLogout = () => {
  // Cancelar cualquier timer previo
  if (timeoutId) {
    clearTimeout(timeoutId);
    timeoutId = null;
  }

  const token = localStorage.getItem('token');
  if (!token) return;

  const payload = decodeJwt(token);
  if (!payload?.exp) return;

  const msUntilExpiry = payload.exp * 1000 - Date.now();

  // Ya venció → logout inmediato
  if (msUntilExpiry <= 0) {
    redirectToLogin();
    return;
  }

  // Programar logout exacto (con margen de 5s para evitar race conditions)
  const timeoutMs = Math.max(0, msUntilExpiry - 5000);

  timeoutId = setTimeout(() => {
    redirectToLogin();
  }, timeoutMs);

  if (import.meta.env.DEV) {
    const min = Math.floor(msUntilExpiry / 60000);
    const seg = Math.floor((msUntilExpiry % 60000) / 1000);
    //console.log(`⏱️ Auto-logout programado en ${min}m ${seg}s`);
  }
};

/**
 * Inicializa el watcher. Llamar UNA sola vez al arrancar la app.
 */
export const initSessionWatcher = () => {
  // 1. Programar según el token actual
  scheduleAutoLogout();

  // 2. Revalidar cuando la pestaña vuelve a estar visible
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      scheduleAutoLogout();
    }
  });

  // 3. Sincronizar entre pestañas
  window.addEventListener('storage', (e) => {
    if (e.key === 'token') {
      scheduleAutoLogout();
    }
  });

  // 4. Revalidar al recuperar foco (con debounce)
  let focusTimeout;
  window.addEventListener('focus', () => {
    if (focusTimeout) clearTimeout(focusTimeout);
    focusTimeout = setTimeout(() => {
      scheduleAutoLogout();
    }, 500); // 👈 debounce de 500ms para evitar múltiples llamadas
  });
};

/**
 * Detiene el watcher (útil al hacer logout manual).
 */
export const stopSessionWatcher = () => {
  if (timeoutId) {
    clearTimeout(timeoutId);
    timeoutId = null;
  }
};